import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
        CALCULATE_OPERATING_PERFORMANCE,
        GET_MISCELLANEOUS_EXPENSES,
        GET_NOTES_TO_OPERATING,
        GET_OPERATING_PERFORMANCE,
        GET_PERSONNEL_PAYMENTS,
} from '../../api/endpoints';
import axiosInstance from '../../utils/axiosInstance';
import openNotification from '../../components/Common/OpenNotification';

const initialState = {
        operatingPerformanceData: [],
        loading: false,
        notesOperating: [],
        personnelPayments: [],
        miscellaneousExpenses: [],
};

export const getOperatingPerformance = createAsyncThunk(
        'operating/getOperatingPerformance',
        async ({ page, pageSize, mnfUnit }, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.get(GET_OPERATING_PERFORMANCE, {
                                params: mnfUnit ? { MNF_UNIT: mnfUnit } : {},
                        });
                        return response.data;
                } catch (error) {
                        openNotification(error?.response?.data?.message || 'Something went wrong.');
                        return rejectWithValue(
                                error?.response?.data?.message || 'Something went wrong.',
                        );
                }
        },
);

export const getNotesOperating = createAsyncThunk(
        'operating/getNotesOperating',
        async ({ page, pageSize, mnfUnit }, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.get(GET_NOTES_TO_OPERATING, {
                                params: mnfUnit ? { MNF_UNIT: mnfUnit } : {},
                        });
                        return response.data;
                } catch (error) {
                        openNotification(error?.response?.data?.message || 'Something went wrong.');
                        return rejectWithValue(
                                error?.response?.data?.message || 'Something went wrong.',
                        );
                }
        },
);

export const getPersonnelPayments = createAsyncThunk(
        'operating/getPersonnelPayments',
        async ({ page, pageSize, mnfUnit }, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.get(GET_PERSONNEL_PAYMENTS, {
                                params: mnfUnit ? { MNF_UNIT: mnfUnit } : {},
                        });
                        return response.data;
                } catch (error) {
                        openNotification(error?.response?.data?.message || 'Something went wrong.');
                        return rejectWithValue(
                                error?.response?.data?.message || 'Something went wrong.',
                        );
                }
        },
);

export const calculateOperatingPerformance = createAsyncThunk(
        'operating/calculateOperatingPerformance',
        async (_, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.post(CALCULATE_OPERATING_PERFORMANCE);
                        return response.data;
                } catch (error) {
                        openNotification(error?.response?.data?.message || 'Something went wrong.');
                        return rejectWithValue(
                                error?.response?.data?.message || 'Something went wrong.',
                        );
                }
        },
);

export const getMiscellaneousExpenses = createAsyncThunk(
        'operating/getMiscellaneousExpenses',
        async ({ page, pageSize, mnfUnit }, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.get(GET_MISCELLANEOUS_EXPENSES, {
                                params: mnfUnit ? { MNF_UNIT: mnfUnit } : {},
                        });
                        return response.data;
                } catch (error) {
                        openNotification(error?.response?.data?.message || 'Something went wrong.');
                        return rejectWithValue(
                                error?.response?.data?.message || 'Something went wrong.',
                        );
                }
        },
);

const operatingSlice = createSlice({
  name: "operating",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Reducer for fetch operating performance
      .addCase(getOperatingPerformance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOperatingPerformance.fulfilled, (state, action) => {
        state.loading = false;
        state.operatingPerformanceData = action.payload.data;
      })
      .addCase(getOperatingPerformance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Reducer for fetch notes operating
      .addCase(getNotesOperating.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNotesOperating.fulfilled, (state, action) => {
        state.loading = false;
        state.notesOperating = action.payload.data;
      })
      .addCase(getNotesOperating.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Reducer for fetch personnel payments
      .addCase(getPersonnelPayments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPersonnelPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.personnelPayments = action.payload.data;
      })
      .addCase(getPersonnelPayments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Reducer for fetch miscellaneous
      .addCase(getMiscellaneousExpenses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMiscellaneousExpenses.fulfilled, (state, action) => {
        state.loading = false;
        state.miscellaneousExpenses = action.payload.data;
      })
      .addCase(getMiscellaneousExpenses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default operatingSlice.reducer;
